/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Text, StyleSheet, View, ScrollView } from "react-native";
import color from "@constants/color";

import { useDispatch, useSelector } from "react-redux";
import { actions as walletActions } from "@reducers/oldWalletReducer";
import { STATE_STATUS } from "@reducers/actionTypes";
import t from "@constants/localization";
import WithdrawTransitionCard from "./components/TransitionCard";
import { ACCOUNT_TYPE } from "./utils";
import WithdrawGullakMoneyHeader from "./components/Header";

const WithDrawGullakMoney = ({ navigation, route }) => {
  const PATH = "screens/WithDrawGullakMoney/index";
  const dispatch = useDispatch();
  const { fundAccountsData = [], fundAccountStatus } = useSelector(
    (state) => state.wallet,
  );
  const [banksList, setBanksList] = useState([]);
  const [upiList, setUpiList] = useState([]);

  useEffect(() => {
    dispatch(walletActions.fetchFundAccounts());
  }, []);

  useEffect(() => {
    if (fundAccountStatus === STATE_STATUS.FETCHED) {
      const tempBanksList = fundAccountsData.filter(
        (account) => account.account_type === ACCOUNT_TYPE.bank,
      );
      const tempUpiList = fundAccountsData.filter(
        (account) => account.account_type !== ACCOUNT_TYPE.bank,
      );

      setBanksList(tempBanksList);
      setUpiList(tempUpiList);
    }
  }, [fundAccountStatus]);

  return (
    <View style={styles.container}>
      <WithdrawGullakMoneyHeader navigation={navigation} route={route} />
      <ScrollView style={styles.contentContainer}>
        <Text style={styles.modeText}>{t(`${PATH}/modeText`)} </Text>
        <WithdrawTransitionCard
          navigation={navigation}
          type={ACCOUNT_TYPE.vpa}
          listData={upiList}
        />
        <WithdrawTransitionCard
          navigation={navigation}
          type={ACCOUNT_TYPE.bank}
          listData={banksList}
        />
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {},
  modeText: {
    fontSize: 16,
    fontWeight: "600",
    color: color.mediumBlacklightBlack,
    marginTop: 20,
    marginLeft: 20,
  },
});

export default WithDrawGullakMoney;
